// extracted by mini-css-extract-plugin
export default {"wrapper":"SetBudget_wrapper__VrXTE","modal":"SetBudget_modal__r4bVA","top":"SetBudget_top__e6CvC","edit":"SetBudget_edit__LphkG"};